var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitiveEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 25H31.25V21.875C31.25 21.0462 30.9208 20.2513 30.3347 19.6653C29.7487 19.0792 28.9538 18.75 28.125 18.75H26.5625V14.0625H32.8125C33.6413 14.0625 34.4362 13.7333 35.0222 13.1472C35.6083 12.5612 35.9375 11.7663 35.9375 10.9375V6.25C35.9375 5.4212 35.6083 4.62634 35.0222 4.04029C34.4362 3.45424 33.6413 3.125 32.8125 3.125H26.5625C25.7337 3.125 24.9388 3.45424 24.3528 4.04029C23.7667 4.62634 23.4375 5.4212 23.4375 6.25V18.75H21.875C21.0462 18.75 20.2513 19.0792 19.6653 19.6653C19.0792 20.2513 18.75 21.0462 18.75 21.875V31.25H12.5C11.6712 31.25 10.8763 31.5792 10.2903 32.1653C9.70424 32.7513 9.375 33.5462 9.375 34.375V43.75C9.375 44.5788 9.70424 45.3737 10.2903 45.9597C10.8763 46.5458 11.6712 46.875 12.5 46.875H37.5C38.3288 46.875 39.1237 46.5458 39.7097 45.9597C40.2958 45.3737 40.625 44.5788 40.625 43.75V28.125C40.625 27.2962 40.2958 26.5013 39.7097 25.9153C39.1237 25.3292 38.3288 25 37.5 25ZM26.5625 6.25H32.8125V10.9375H26.5625V6.25ZM12.5 34.375H18.75V43.75H12.5V34.375ZM21.875 21.875H28.125V43.75H21.875V21.875ZM37.5 43.75H31.25V28.125H37.5V43.75Z",
    fill: "#033832"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitiveEdge);
export default __webpack_public_path__ + "static/media/competitive-edge.c2d3c5ccc6a491a7e1260225fe0c9edf.svg";
export { ForwardRef as ReactComponent };